import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from 'src/app/services/user.service';
import { UserInfo } from 'src/app/core/classes/user-info';
import { RedirectService } from 'src/app/services/redirect.service';

@Component({
  selector: 'redirect',
  templateUrl: './redirect.component.html'
})
export class RedirectComponent implements OnInit {

  public TURN_MARKET_ID: number = 1;

  constructor(
    private router: Router,
    private redirectService: RedirectService,
    private userService: UserService) { }

  public ngOnInit() {
    const returnUrl = this.redirectService.getReturnUrl();
    if (returnUrl) {
      this.router.navigateByUrl(returnUrl);
    } else {
      this.userService.getUser().then((userObject: UserInfo) => {
        let marketId = userObject.marketId;
        if (marketId < 0 && userObject.userType === 'clientServices') {
          // default to turn market for CS user
          marketId = this.TURN_MARKET_ID;
        }
        this.router.navigate(['market-dashboard', marketId]);
      });
    }
  }
}
